import { createActions } from "redux-actions";

const actions = createActions(
  {
    SET: (lat, lng) => ({ lat, lng }),
  },
  { prefix: "LOCATION" },
);

export const {
  set,
} = actions;
